import { getClinicStocksWoLoader } from "../redux/reducers/clinicSlice";
import {
  patchMandateSession,
  readMandateSession,
} from "./mandateSessionStorage";

/**
 * Fetch clinic stocks and persist them to mandate session.
 * Safe no-op on errors / empty payloads.
 */
export const refreshClinicStocksToSession = (dispatch, inventryData) => {
  try {
    const sharing =
      inventryData !== undefined && inventryData !== null
        ? inventryData
        : (readMandateSession()?.dataSharing?.inventryData ?? false);

    return Promise.resolve(
      dispatch(getClinicStocksWoLoader(`?inventryData=${sharing}`)),
    )
      .then((stcRes) => {
        try {
          if (stcRes?.payload == null) return;
          const stocks = Array.isArray(stcRes?.payload?.data)
            ? stcRes.payload.data
            : Array.isArray(stcRes?.payload)
              ? stcRes.payload
              : [];
          patchMandateSession({ stocks });
        } catch {
          // ignore session patch errors
        }
      })
      .catch(() => {
        // ignore stock refresh errors
      });
  } catch {
    return Promise.resolve();
  }
};
